export const getTime = (date) => {
  if (date && date.length > 10) {
    let hours = date.substring(11, 13);
    const minutes = date.substring(14, 16);
    return (
      new Date("1970-01-01T" + hours + ":" + minutes + "Z").toLocaleTimeString(
        "en-US",
        {
          timeZone: "UTC",
          hour12: true,
          hour: "numeric",
          minute: "numeric",
        }
      ) + " EST"
    );
  } else {
    return "EST";
  }
};

export function cleanObjectFromNullProperties(obj: Object): Object {
  Object.keys(obj).forEach(
    (key: string) => obj[key] == null && delete obj[key]
  );
  return obj;
}

export function cleanObjectFromUndefinedProperties(obj: Object): Object {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
  });
  return newObj;
}

export function generateId(): string {
  return "id_" + Math.random().toString(16).slice(2);
}

export function removeExtraSpaces(value: string): string {
  return value?.replace(/\s\s+/g, ' ');
}
